import {
  Flex,
  ModalOverlay,
  ModalContent,
  Modal,
  ModalBody,
  Text,
  Divider,
  ModalCloseButton,
} from '@chakra-ui/react';
import { CompositionGroupView } from './CompositionGroupView';
import { SimpleNote } from '@texas/components/shared/SimpleNote';
import { useTranslation } from 'react-i18next';
import { CopyConfig } from '@texas/api/endpoints/compositionGroup/compositionGroupApi';
import { CompositionGroupCopyConfig } from './CompositionGroupCopyConfig';

export interface CopyConfigOptions {
  linkedVariantId: number | null;
  sourceGroupNote?: string | null;
}

export function ConfirmCopy({
  compositionGroupId,
  onConfirm,
  isOpen,
  title,
  buttonLabel,
  onClose,
  copyConfigOptions,
  hideCopyConfig,
}: {
  compositionGroupId: number;
  onConfirm: (id: number, copyConfig?: CopyConfig) => void;
  isOpen: boolean;
  title: string;
  buttonLabel: string;
  onClose: () => void;
  copyConfigOptions?: CopyConfigOptions;
  hideCopyConfig?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent width="auto" maxW="fit-content">
        <ModalCloseButton />
        <ModalBody>
          <Flex align="center" flexDir="column">
            <Text>{title}</Text>
            <SimpleNote color="yellow.400" _light={{ color: 'orange.500' }}>
              {t('compositionGroup.copyNoEdit')}
            </SimpleNote>
          </Flex>
          <Divider py={2} />
          <Flex flexDir="row" gap={4}>
            <CompositionGroupView
              variantId={0}
              compositionGroupId={compositionGroupId}
              componentSettings={{
                compositionArchiveRestore: 'hidden',
                addMaterials: 'hidden',
                materialsMode: 'read-only',
                removeMaterials: 'hidden',
                editImage: 'hidden',
                dimensionMode: 'read-only',
              }}
            />
            {!hideCopyConfig && (
              <Flex
                flexDir="column"
                p={4}
                borderLeft="1px solid"
                borderColor="gray.200"
                minW="200px"
              >
                <CompositionGroupCopyConfig
                  compositionGroupId={compositionGroupId}
                  linkedVariantId={copyConfigOptions?.linkedVariantId}
                  sourceGroupNote={copyConfigOptions?.sourceGroupNote}
                  buttonLabel={buttonLabel}
                  onConfirm={onConfirm}
                />
              </Flex>
            )}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
